import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import { PLAN_REVIEW_COMMENTS_SECTION } from '../config/justification'
import type { IPlanReviewJustificationParams } from '../model/types'

import type { IPlanReviewCommentApi } from './types'

interface ISavePlanReviewJustificationParams {
  entryId: number
  partnerId: string
  params: IPlanReviewJustificationParams
  comment: string
}

export const savePlanReviewJustification = async ({
  entryId,
  partnerId,
  params,
  comment,
}: ISavePlanReviewJustificationParams): Promise<IPlanReviewCommentApi | null> => {
  const response = await callProcedure<IProcedureResponse<IPlanReviewCommentApi[]>>({
    url: '/webservice/621/sp/v4/spJBPCommentsApplyChanges/call',
    method: 'POST',
    data: {
      'p.EntryID': entryId,
      'p.PartnerId': partnerId,
      'p.Params': JSON.stringify(params),
      'p.Section': PLAN_REVIEW_COMMENTS_SECTION,
      'p.Comment': comment,
      'p.IsDel': 0,
    },
  })

  if ('error' in response) {
    throw response.error
  }

  return response.data?.Data?.[0] ?? null
}
